import * as React from 'react';
import { FC } from 'react';

import SanityBlockRenderer, {
  IBlockContentOverrides,
  ISerializers,
  PassthroughComponent,
} from 'components/sanity-block-renderer';

import { Name } from './styled';
import { IItemNameProps } from './types';

const nameBlockContentOverrides: IBlockContentOverrides = {
  normal: Name,
};

const nameBlockSerializers: ISerializers = {
  marks: {
    em: PassthroughComponent,
  },
  container: PassthroughComponent,
};

export const OfferItemName: FC<React.PropsWithChildren<IItemNameProps<'offer'>>> = ({
  entryCartDetails: { offer },
}) => (
  <SanityBlockRenderer
    blockContentOverrides={nameBlockContentOverrides}
    serializers={nameBlockSerializers}
    content={offer?.name?.localeRaw}
  />
);

export const RewardItemName: FC<React.PropsWithChildren<IItemNameProps<'reward'>>> = ({
  entryCartDetails: { reward },
}) => (
  // @ts-expect-error TS(2339) FIXME: Property 'en' does not exist on type '{ readonly _... Remove this comment to see the full error message
  <Name>{reward?.name?.en || ''}</Name>
);
